import { createGlobalStyle } from 'styled-components'
import { fonts } from './fonts';
import { global } from './global';
import { slick } from './slick';
import { slickTheme } from './slick-theme';
import { emojiTheme } from './emoji-mars-theme';

export const GlobalStyle = createGlobalStyle`
  ${fonts};
  ${global};
  ${slick};
  ${slickTheme};
  ${emojiTheme};
`;
